export default "__VITE_ASSET__B8fa2HH6__"